module.exports = __webpack_public_path__ + "static/img/grow-group.051a3919.png";